/**
 * PropTypes treats null and undefined as the same thing, which means it can't
 * properly type things that are allowed to be *explicitly* null, i.e. disabling
 * a feature because the relevant data doesn't exist.
 *
 * This validator wraps a standard PropType chain and adds that check to avoid
 * failing.
 *
 * https://github.com/facebook/react/issues/3163#issuecomment-470307646
 *
 * @example
 * ```diff
 * - // Didn't work anyway
 * - someProp: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf([null])]).isRequired,
 * + someProp: nullablePropType(PropTypes.number).isRequired
 * ```
 */
export function nullablePropType(subRequirement) {
  const check = (required, props, key, ...rest) => {
    if (props[key] === null) {
      return null;
    }
    const sub = required ? subRequirement.isRequired : subRequirement;
    return sub(props, key, ...rest);
  };
  const fn = check.bind(null, false);
  fn.isRequired = check.bind(null, true);
  return fn;
}
